import { TenorFieldUnitOption } from 'components/shared/TenorField/TenorField';
import { KeyboardEvent, useCallback, useState } from 'react';

type UseTenorUnitsProps = {
  initialUnit: string;
  availableUnits: TenorFieldUnitOption[];
};

export const useTenorUnits = ({ initialUnit, availableUnits }: UseTenorUnitsProps) => {
  const [unit, setUnit] = useState<string>(initialUnit);

  const onUnitChange = useCallback(
    (newUnit: string) => {
      if (unit !== newUnit) {
        setUnit(newUnit);
      }
    },
    [unit],
  );

  const onInputKeyPress = useCallback(
    (event: KeyboardEvent<Element>) => {
      const matchedUnit = availableUnits.find(
        u => u.shortcut !== undefined && u.shortcut.toLowerCase() === event.key.toLowerCase(),
      );
      if (matchedUnit) {
        onUnitChange(matchedUnit.value);
      }
    },
    [availableUnits, onUnitChange],
  );

  return { onInputKeyPress, unit, setUnit };
};
